import clsx from "clsx";
import {
  APP_LOCAL_STORAGE_ACCOUNTS,
  FILE_STORAGE_SERVER_URL,
} from "../../helpers/constants";
import { getShortName } from "../../helpers/utils";
import { motion } from "framer-motion";

import { MdFace } from "react-icons/md";
import Badge from "../Badge/Badge";
import useDarkMode from "src/hooks/useDarkMode";

interface ILocalStorageUsers {
  onClick?: (params: any) => void;
  active: string;
}

const LocalStorageUsers: React.FC<ILocalStorageUsers> = ({
  onClick = () => {},
  active,
}) => {
  const accounts = localStorage.getItem(APP_LOCAL_STORAGE_ACCOUNTS);
  const { isEnabled: isDarkMode } = useDarkMode();

  const parsedAccounts = accounts ? JSON.parse(accounts) : [];

  if (!parsedAccounts?.length) {
    return null;
  }

  return (
    <div className={clsx(["w-full", "flex"])}>
      <div
        className={clsx([
          "overflow-x-hidden",
          "relative",
          "flex",
          "flex-col",
          "w-full",
          "items-center",
        ])}
      >
        <div
          className={clsx([
            "h-full",
            "absolute",
            "left-0",
            "top-0",
            "bottom-0",
            "w-9",
            "bg-gradient-to-l",
            "from-transparent",
            "to-white",
            "dark:to-gray-800",
            "z-10",
            "pointer-events-none",
            "flex-shrink-0",
            "hidden",
            "md:flex",
          ])}
        />

        <ul
          className={clsx([
            "flex",
            "flex-grow",
            "flex-row",
            "md:gap-4",
            "gap-3",
            "overflow-x-auto",
            "no-scrollbar",
            "max-w-full",
            "px-8",
            "md:h-[160px]",
            "h-[130px]",
          ])}
        >
          {parsedAccounts?.map?.((account: any, key: number) => (
            <motion.li
              initial={{
                opacity: 0.2,
              }}
              animate={{
                opacity: 1,
              }}
              transition={{
                duration: 1,
              }}
              key={key}
              className={clsx([
                "cursor-pointer",
                "transition-all",
                "gap-2",
                "flex",
                "flex-col",
                "items-center",
                "justify-center",
                "rounded-xl",
                {
                  "dark:bg-gray-800 opacity-20":
                    active && active !== account.email,
                  "scale-125 bg-secondary-50 dark:bg-gray-700 border-transparent":
                    active === account.email,
                },
              ])}
              onClick={() => {
                if (active === account.email) {
                  onClick("");
                } else {
                  onClick(account.email);
                }
              }}
            >
              {account.picture ? (
                <motion.img
                  src={`${FILE_STORAGE_SERVER_URL}/profile-thumbnail-${account.picture}`}
                  alt="Imagen"
                  className={clsx([
                    "w-full",
                    "h-full",
                    "md:max-h-[120px]",
                    "md:max-w-[120px]",
                    "md:min-h-[120px]",
                    "md:min-w-[120px]",
                    "max-h-[90px]",
                    "max-w-[90px]",
                    "min-h-[90px]",
                    "min-w-[90px]",
                    "object-cover",
                    "rounded-lg",
                    "shadow-lg",
                    "bg-checkers",
                  ])}
                  whileHover={{ scale: 0.8 }}
                  whileTap={{ scale: 0.8 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                />
              ) : (
                <MdFace size={54} />
              )}
              <div
                className={clsx([
                  "text-sm",
                  "md:text-sm",
                  "w-full",
                  "justify-center",
                  "truncate",
                  "hidden",
                  "md:flex",
                ])}
              >
                {isDarkMode ? (
                  <Badge text={getShortName(account.name) || "Sin nombre"} />
                ) : (
                  <Badge
                    text={getShortName(account.name) || "Sin nombre"}
                    // kind="danger"
                  />
                )}
              </div>
            </motion.li>
          ))}
        </ul>

        <div
          className={clsx([
            "h-full",
            "absolute",
            "right-0",
            "top-0",
            "bottom-0",
            "w-9",
            "bg-gradient-to-r",
            "from-transparent",
            "to-white",
            "dark:to-gray-800",
            "z-10",
            "pointer-events-none",
            "flex-shrink-0",
            "hidden",
            "md:flex",
          ])}
        />
      </div>
    </div>
  );
};

export default LocalStorageUsers;
